/**
 * Text ellipsis component to show more/less any text
 */
export default class Ellipsis {
	constructor() {
		this.initEvents();
	}

    initEvents() {
        this.makeEllipsis();
	}

    /**
     * Main method
     */
    makeEllipsis() {
        let truncateDivs = document.querySelectorAll('.truncate-div');

        for(let div of truncateDivs) {
            let text = div.querySelector('.text-ellipsis');
            let parent = text.parentElement;
            let toggle = div.querySelector('.show-more-ellipsis');
            let tglTxt = toggle.querySelector('.read');

            parent.classList.add('hideContent');

            toggle.addEventListener('click',() => {
                if(parent.classList.contains('hideContent')) {
                    this.showText(parent, tglTxt);
                }
                else {
                    this.hideText(parent, tglTxt);
                }
            });

            this.showToggle(text, parent, toggle);
            window.addEventListener('resize', () => {this.showToggle(text, parent, toggle)});
        }
    }

    /**
     * Is overflown
     * @param txt
     * @param parent
     * @returns {boolean}
     */
    isOverflown(txt, parent) {
        return txt.clientHeight > parent.clientHeight;
    }

    /**
     * Show toggle
     * @param text
     * @param parent
     * @param toggle
     */
    showToggle(text, parent, toggle) {
        this.hideText(parent, toggle.querySelector('.read'))
        if(this.isOverflown(text, parent)){
            toggle.style.display = 'block';

        } else {
            toggle.style.display = '';
        }
    }

    /**
     * Hide text
     * @param parent
     * @param tglTxt
     */
    hideText(parent, tglTxt) {
        parent.classList.remove('showContent');
        parent.classList.add('hideContent');
        tglTxt.innerHTML = window.jsTranslations['read_more'];
    }

    /**
     * Show text
     * @param parent
     * @param tglTxt
     */
    showText(parent, tglTxt) {
        parent.classList.add('showContent');
        parent.classList.remove('hideContent');
        tglTxt.innerHTML = window.jsTranslations['read_less'];
    }
}
